// import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetQuestions,
    requestGetQuestionById,
    requestCreateQuestion,
    requestUpdateQuestionById,
    requestDeleteQuestion,

    requestGetHeaders,
    requestGetHeaderById,
    requestCreateHeader,
    requestUpdateHeaderById,
    requestDeleteHeaderById
} from "api/menu/master-files/question-library/requests";

export const QL_LOADING = "QL_LOADING";
export const QL_ERROR = "QL_ERROR";

export const QL_HEADERS_GET = "QL_HEADERS_GET";
export const QL_HEADER_GET_BY_ID = "QL_HEADER_GET_BY_ID";
export const QL_HEADER_UPDATE = "QL_HEADER_UPDATE";
export const QL_HEADER_DELETE = "QL_HEADER_DELETE";

export const QL_QUESTIONS_GET = "QL_QUESTIONS_GET";
export const QL_QUESTION_GET_BY_ID = "QL_QUESTION_GET_BY_ID";
export const QL_QUESTION_UPDATE = "QL_QUESTION_UPDATE";
export const QL_QUESTION_DELETE = "QL_QUESTION_DELETE";

export const setLoading = (status) => ({
    type: QL_LOADING,
    payload: status
});

export const getHeaders = (jobId, includeInactive) => dispatch => {
    dispatch(setLoading(true));
    requestGetHeaders(jobId, includeInactive)
        .then(response => {
            dispatch({
                type: QL_HEADERS_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const getHeaderById = (headerId) => dispatch => {
    dispatch(setLoading(true));
    requestGetHeaderById(headerId)
        .then(response => {
            dispatch({
                type: QL_HEADER_GET_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const createHeader = (data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestCreateHeader(data)
        .then(response => {
            dispatch({
                type: QL_HEADER_UPDATE,
                payload: response.data
            });
            if (callback) {
                callback(response.data);
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const updateHeaderById = (id, data) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateHeaderById(id, data)
        .then(response => {
            dispatch({
                type: QL_HEADER_UPDATE,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const deleteHeaderById = (id) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteHeaderById(id)
        .then(() => {
            dispatch({
                type: QL_HEADER_DELETE,
                payload: id
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const getQuestions = (includeInactive = false) => dispatch => {
    dispatch(setLoading(true));
    requestGetQuestions(includeInactive)
        .then(response => {
            dispatch({
                type: QL_QUESTIONS_GET,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const getQuestionById = (questionId) => dispatch => {
    dispatch(setLoading(true));
    requestGetQuestionById(questionId)
        .then(response => {
            dispatch({
                type: QL_QUESTION_GET_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const getQuestionByIdWithCallback = (questionId, callback) => () => {
    requestGetQuestionById(questionId)
        .then(response => {
            callback(response.data);
        })
        .catch(() => {
            callback([]);
        });
};

export const createQuestion = (data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestCreateQuestion(data)
        .then(response => {
            dispatch({
                type: QL_QUESTION_UPDATE,
                payload: response.data
            });
            if (callback) {
                callback(response.data);
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const updateQuestionById = (id, data) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateQuestionById(id, data)
        .then(response => {
            dispatch({
                type: QL_QUESTION_UPDATE,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};

export const deleteQuestionById = (id) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteQuestion(id)
        .then(() => {
            dispatch({
                type: QL_QUESTION_DELETE,
                payload: id
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, QL_ERROR));
        });
};
